import { useState, useEffect, useCallback } from 'react';
import { Form, Button, Col, Row, Card, InputGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FaDolly, FaUser, FaMapMarkerAlt, FaTruck } from 'react-icons/fa';
import FormContainer from '../components/FormContainer';
import { saveShippingAddress } from '../slices/cartSlice';
import CheckoutStatusBar from '../components/CheckoutStatusBar.jsx';
import CheckoutStatusBar1 from '../components/CheckoutStatusBar1.jsx';
import countryTR from '../assets/styles/countryTR.js';

const ShippingScreen = () => {
  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;
  const { userInfo } = useSelector((state) => state.auth);
  
  const [companyCity] = useState(shippingAddress?.companyCity || '');
  const [companyState] = useState(shippingAddress?.companyState || '');
  const [companyName] = useState(shippingAddress?.companyName || '');
  const [companyAddress] = useState(shippingAddress?.companyAddress || '');
 
  const [name] = useState(shippingAddress?.name || '');
  const [surname] = useState(shippingAddress?.surname || '');
  const [email] = useState(shippingAddress?.email || '');
  const [phoneNumber] = useState(shippingAddress?.phoneNumber || '');
  const [idNumber] = useState(shippingAddress?.idNumber || '');
  const [taxNumber] = useState(shippingAddress?.taxNumber || '');
  const [taxState] = useState(shippingAddress?.taxState || '');
  const [isCompany] = useState(shippingAddress?.isCompany);
  
  const [address, setAddress] = useState(shippingAddress?.address || '');
  const [city, setCity] = useState(cart.shippingAddress?.city || shippingAddress?.companyCity || '');
  const [state, setState] = useState(cart.shippingAddress?.state || shippingAddress?.companyState || '');
  const [receiver, setReceiver] = useState(cart.shippingAddress?.receiver || shippingAddress?.receiver || '');
  const [cargoSelection, setCargoSelection] = useState(cart.shippingAddress?.cargoSelection || shippingAddress?.cargoSelection || 'Yurtiçi Kargo');
  
  const [cities, setCities] = useState(
    countryTR.find(ctr => ctr.il === `${shippingAddress?.companyState ? shippingAddress.companyState : 'Seçiniz'}`)?.ilceleri || ''
  );
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
   
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [chng, setchng] = useState('');

  const submitHandler = (e) => {
    e.preventDefault();
    setFormErrors(validate());
    setIsSubmit(true);
  };

  const validate = () => {
    const errors = {};
    if (!receiver) errors.receiver = "Alıcı adını giriniz";
    if (!city) errors.city = "İlçeyi seçiniz";
    if (!state || state === "Seçiniz") errors.state = "Şehri seçiniz";
    if (!address) errors.address = "Açık adresi giriniz";
    return errors;
  };
      
  const submitHandler2 = useCallback(() => {
    setchng("");
    dispatch(saveShippingAddress({
      address, city, state, receiver, cargoSelection, companyCity, companyState, 
      companyName, companyAddress, name, surname, email, phoneNumber, 
      idNumber, taxNumber, taxState, isCompany
    }));
    navigate('/payment');
  }, [dispatch, navigate, address, city, state, receiver, cargoSelection, companyCity, companyState, companyName, companyAddress, name, surname, email, phoneNumber, idNumber, taxNumber, taxState, isCompany]);

  useEffect(() => {
    if (chng === "1") {
      submitHandler2();
    }
  }, [chng, submitHandler2]);
    
  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      setchng("1");
    }
  }, [formErrors, isSubmit]);

  const changeState = (e) => {
    setState(e.target.value);
    const foundState = countryTR.find(ctr => ctr.il === e.target.value);
    if (foundState) {
      setCities(foundState.ilceleri);
      setCity(foundState.ilceleri[0]);
    }
  };

  return (
    <div style={{ paddingTop: '10px', paddingBottom: '10px', backgroundColor: '#f8f9fa' }}>
      <FormContainer>
        {userInfo ? <CheckoutStatusBar1 step2 /> : <CheckoutStatusBar userfill step2 />}
        
        {/* REVIZYON: Kart stilleri, başlık rengi (#004488) ve üst boşluk (-20px) UserFill ile tam eşitlendi */}
        <Card  className="border-0 shadow-sm rounded-4 overflow-hidden mb-4" 
  style={{ 
    borderTop: '4px solid #004488',
    marginTop: '40px',    // Negatif margin ile aradaki dikey beyaz boşluk tamamen kapatıldı
    position: 'relative',
    zIndex: 0
  }}>
          <Card.Header className="text-white p-3 border-0" style={{ backgroundColor: '#66CCFF' }}>
            <h4 className="m-0 fw-bold fs-5 d-flex align-items-center gap-2">
              <FaDolly /> Sevkiyat ve Teslimat Bilgileri
            </h4>
          </Card.Header>
          <Card.Body className="p-4 bg-white">
            <Form onSubmit={submitHandler}>
              
              {/* ALICI ADI ALANI (UserFill Girdi Tasarım Şeması) */}
              <Row>
                <Col md={12}>
                  <Form.Group controlId='receiver' className='mb-3'>
                    <Form.Label className="fw-bold text-muted small">Alıcı Adı / Firma Ünvanı</Form.Label>
                    <InputGroup>
                      <InputGroup.Text className="bg-light border-secondary-subtle"><FaUser className="text-muted" /></InputGroup.Text>
                      <Form.Control
                        type='text'
                        placeholder='Teslim alacak kişinin adı veya firma ünvanı'
                        value={receiver}
                        onChange={(e) => setReceiver(e.target.value)}
                        className="py-2 rounded-end-3 border-secondary-subtle fw-semibold"
                      />
                    </InputGroup>
                    {formErrors.receiver && <small className="text-danger d-block mt-1 font-monospace">{formErrors.receiver}</small>}
                  </Form.Group>
                </Col>
              </Row>

              {/* İL / İLÇE SEÇİM ALANI */}
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group controlId='state' className='mb-3'>
                    <Form.Label className="fw-bold text-muted small">İl</Form.Label>
                    <Form.Select value={state} onChange={changeState} className="py-2 rounded-3 border-secondary-subtle" style={{ cursor: 'pointer' }}>
                      <option value="Seçiniz">Seçiniz</option>
                      {countryTR.map((ctr) => (
                        <option key={ctr.il} value={ctr.il}>{ctr.il}</option>
                      ))}
                    </Form.Select>
                    {formErrors.state && <small className="text-danger d-block mt-1 font-monospace">{formErrors.state}</small>}
                  </Form.Group> 
                </Col>

                <Col xs={12} md={6}>
                  <Form.Group controlId='city' className='mb-3'>
                    <Form.Label className="fw-bold text-muted small">İlçe</Form.Label>
                    <Form.Select 
                      value={city} 
                      onChange={(e) => setCity(e.target.value)} 
                      className="py-2 rounded-3 border-secondary-subtle"
                      style={{ cursor: 'pointer' }}
                      disabled={!cities}
                    >
                      {cities && cities.map((cityOpt) => (
                        <option key={cityOpt} value={cityOpt}>{cityOpt}</option>
                      ))}
                    </Form.Select>
                    {formErrors.city && <small className="text-danger d-block mt-1 font-monospace">{formErrors.city}</small>}
                  </Form.Group>
                </Col>
              </Row>

              {/* SEVK ADRESİ ALANI */}
              <Row>
                <Col md={12}>
                  <Form.Group controlId='address' className='mb-3'>
                    <Form.Label className="fw-bold text-muted small">Sevk Adresi</Form.Label>
                    <InputGroup>
                      <InputGroup.Text className="bg-light border-secondary-subtle"><FaMapMarkerAlt className="text-muted" /></InputGroup.Text>
                      <Form.Control
                        as="textarea" 
                        rows={3}
                        placeholder='Mahalle, Sokak, No, Daire bilgilerini eksiksiz yazınız.'
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        className="rounded-end-3 border-secondary-subtle"
                      />
                    </InputGroup>
                    {formErrors.address && <small className="text-danger d-block mt-1 font-monospace">{formErrors.address}</small>}
                  </Form.Group>
                </Col>
              </Row>  
{/* KARGO SEÇİM ALANI - BOOTSTRAP KURAL YIKICI KESİN ÇÖZÜM */}
<div className="my-2 p-2 bg-light rounded-3 border">
  <Form.Label className="fw-bold text-dark d-block mb-2 small" style={{ fontSize: '0.85rem' }}>
    <FaTruck className="me-1 text-muted" /> Kargo Tercihi
  </Form.Label>
  
  {/* Ana sarmalayıcı - Boşluk sıfır, Bootstrap kartları yerine saf div'ler kullanıldı */}
  <div style={{ display: 'flex', flexDirection: 'column', gap: '0px', width: '100%' }}>
    
    {/* 1. SEÇENEK: YURTİÇİ KARGO (Saf HTML Div) */}
    <div 
      onClick={() => setCargoSelection('Yurtiçi Kargo')}
      style={{ 
        cursor: 'pointer', 
        transition: 'all 0.2s', 
        backgroundColor: '#ffffff',
        padding: '12px',
        border: '1px solid #dee2e6',
        borderBottom: 'none', // Arttaki çift çizgi görüntüsünü engellemek için alt kenarlık yok
        borderTopLeftRadius: '6px',
        borderTopRightRadius: '6px',
        margin: '0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'between',
        boxShadow: '0 .125rem .25rem rgba(0,0,0,.075)'
      }}
    >
      <div className="d-flex align-items-center justify-content-between w-100">
        <div className="d-flex align-items-center gap-2">
          <Form.Check
            type='radio'
            id='yurtici'
            name='cargo'
            value='Yurtiçi Kargo'
            checked={cargoSelection === 'Yurtiçi Kargo'}
            onChange={(e) => setCargoSelection(e.target.value)}
            style={{ cursor: 'pointer', margin: 0 }}
          />
          <img src='/images/yurtici.jpg' alt="Yurtiçi" style={{ height: '50px', objectFit: 'contain' }} />
        </div>
        <span className="fw-bold font-monospace" style={{ fontSize: '0.8rem', color: '#0a5c2b' }}>Ücretsiz Kargo</span>
      </div>
    </div>
    
    {/* 2. SEÇENEK: ARAS KARGO (Saf HTML Div) */}
    <div 
      onClick={() => setCargoSelection('Aras Kargo')}
      style={{ 
        cursor: 'pointer', 
        transition: 'all 0.2s', 
        backgroundColor: '#ffffff',
        padding: '12px',
        border: '1px solid #dee2e6',
        borderBottomLeftRadius: '6px',
        borderBottomRightRadius: '6px',
        margin: '0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'between',
        boxShadow: '0 .125rem .25rem rgba(0,0,0,.075)'
      }}
    >
      <div className="d-flex align-items-center justify-content-between w-100">
        <div className="d-flex align-items-center gap-2">
          <Form.Check
            type='radio'
            id='aras'
            name='cargo'
            value='Aras Kargo'
            checked={cargoSelection === 'Aras Kargo'}
            onChange={(e) => setCargoSelection(e.target.value)}
            style={{ cursor: 'pointer', margin: 0 }}
          />
          <img src='/images/aras.jpg' alt="Aras" style={{ height: '50px', objectFit: 'contain' }} />
        </div>
        <span className="fw-bold font-monospace" style={{ fontSize: '0.8rem', color: '#0a5c2b' }}>Ücretsiz Kargo</span>
      </div>
    </div>

  </div>
</div>

     
              {/* REVIZYON: Buton nitelikleri, boyutları ve animasyonu tamamen UserFill ile eşlendi */}
              <Button 
                type='submit' 
                className='w-100 border-0 fw-bold transition-all shadow-sm' 
                style={{ 
                  backgroundColor: '#2b2b2b',
                  color: '#ffffff',
                  height: '46px',
                  borderRadius: '4px',
                  fontSize: '0.85rem',
                  letterSpacing: '0.5px',
                  transition: 'all 0.2s ease-in-out'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#66CCFF'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#2b2b2b'}
              >
                Bilgileri Kaydet ve Devam Et
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </FormContainer>
    </div>
  );
};

export default ShippingScreen;
